import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../Invoice/quickSales.css";
import useApi from "../../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../../../../utils/secure-route/AuthContext";
import { ToastContainer } from "react-toastify";
import scanner from "../../../../../assets/Image/scan.png";
import Invoice from "../../../../../assets/Image/invoice1.png"
import QuickInvoicemodal from "./QuickInvoicemodal";
import { useToastHandler } from "../../../../common/ToastHandler";
import useFormattingUtils from "../../../../../context/useFormattingUtils";
import { useShift } from "../../Lottery/ShiftContext";
import CustomDateInput from "../../../../../context/CustomDateInput";
function QuickInvoice() {
  const [, setActiveButton] = useState("");
  const [productInventory, setProductInventory] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showInvoice, setShowInvoice] = useState(false);
  const { user } = useContext(AuthContext);
  const storeId = user.store;
  const { handleToast } = useToastHandler()
  const handleCloseModal = () => setShowInvoice(false);
  const [modalData, setModalData] = useState(null);
  const [additionalDiscount, setAdditionalDiscount] = useState("0");
  const [, setRoundOffAmount] = useState(0);
  const [barcodeInput, setBarcodeInput] = useState("");
  const [, setIsUserActive] = useState(false);
  const [, setActiveField] = useState(null);
  const [, setHoveredRowIndex] = useState(null);
  const [roundOffEnabled, setRoundOffEnabled] = useState(false);
  const [, setCurrentPage] = useState(1);
  const [, setTotalCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [focusedIndex, setFocusedIndex] = useState(null); 
  const [searchResults, setSearchResults] = useState([]);
  const [floatingDropdownStyle, setFloatingDropdownStyle] = useState(null);
  const [, setIsSearching] = useState(false)
  const [, setTotalPages] = useState(1);
  const itemsPerPage = 10;

  const [products, setProducts] = useState([
    {
      store: storeId,
      barcode: "",
      additional_discount_value: "0",
      title: "",
      qty: 0,
      discount: 0,
      discount_percentage: 0,
      selling_price: 0,
      uom: "",
      amount: 0,
      total: 0,
      sold_qty_stock: 0,
      product_inventory: "",
      roundOff: 0,
    },
  ]);
  const [formData, setFormData] = useState({
    store: storeId,
    barcode: "",
    sr_no: "",
    date: new Date().toISOString().split("T")[0],
    transaction_type: "Sales Invoice",
    invoice_no: "",
    customer: "",
    additional_discount_value: "0",
    bank: "",
    amount: "",
    cash_amount: "",
    cheque_amount: "",
    cheque_no: "",
    total_amount: "",
    pay_method_status: "pay_now",
    pay_method: "cash",
    note: "",
    atm_commission: "",
    income_type: null,
    bank_deposite_type: null,
    owner: null,
  });
  const location = useLocation();
  const { formatCurrency } = useFormattingUtils();
  const isRetailRoute = location.pathname.toLowerCase().includes("retail");
  const pageBadgeLabel = isRetailRoute ? "Quick Retail Billing" : "Quick Invoice Billing";
  const pageTitle = isRetailRoute ? "Retail Invoice" : "Quick Invoice";
  const pageSubtitle = isRetailRoute
    ? "Search products or scan barcode to bill a retail sale from one clean workspace."
    : "Scan, add products, collect payment and print invoice from one clean workspace.";
  const { shiftData, startShift } = useShift();
  const [showShiftRequiredModal, setShowShiftRequiredModal] = useState(false);
  const [startingShiftForSale, setStartingShiftForSale] = useState(false);
  const [pendingSubmitOpenModal, setPendingSubmitOpenModal] = useState(false);
  const { Post, getAPI, PostPaginatedData, Get } = useApi();
  const [terminals, setTerminals] = useState([]);
  const [selectedTerminal, setSelectedTerminal] = useState(null);
  const [showTerminalModal, setShowTerminalModal] = useState(false);
  const [terminalStatus, setTerminalStatus] = useState("IDLE");
  const [terminalMessage, setTerminalMessage] = useState("");
  const pollingRef = React.useRef(null);

  useEffect(() => {
    if (storeId) {
      Get(`${getAPI('paymentTerminals')}?store_id=${storeId}`)
        .then((data) => {
          setTerminals(data || []);
          if (data && data.length > 0) {
            const def = data.find((t) => t.is_default) || data[0];
            setSelectedTerminal(def);
          }
        })
        .catch((err) => console.error("Error fetching terminals:", err));

      Get(`${getAPI('configurationForStore')}?store=${storeId}`)
        .then((res) => {
          const cfg = res?.results?.[0] || res?.data?.[0] || res?.[0] || res;
          if (cfg && cfg.default_pay_method) {
            setFormData(prev => ({ ...prev, pay_method: cfg.default_pay_method }));
          }
        })
        .catch((err) => console.error("Error fetching store config:", err));
    }
  }, [storeId]);

  useEffect(() => {
    if (storeId) {
      setProducts((prevProducts) =>
        prevProducts.map(
          (product) =>
            product.store ? product : { ...product, store: storeId }
        )
      );
      setFormData((prevFormData) => ({ ...prevFormData, store: storeId }));
    }
  }, [storeId]);

  const handleCancel = () => {

    setFormData({
      store: storeId,
      barcode: "",
      sr_no: "",

      customer: "",
      date: new Date().toISOString().split("T")[0],
      transaction_type: "Sales Invoice",
      customer_name: "",
      additional_discount_value: "0",
      bank: "",
      amount: "",
      cash_amount: "",
      cheque_amount: "",
      cheque_no: "",
      total_amount: "",
      pay_method_status: "pay_now",
      pay_method: "cash",

      atm_commission: "",
      income_type: null,
      bank_deposite_type: null,
      owner: null,
    });

    setProducts([
      {
        store: storeId,
        barcode: "",
        additional_discount_value: "0",
        title: "",
        qty: 0,
        discount: 0,
        discount_percentage: 0,
        selling_price: 0,
        uom: "",
        amount: 0,
        total: 0,
        sold_qty_stock: 0,
        product_inventory: "",
        roundOff: 0,
      },
    ]);
  };
  const filteredInventory = Array.isArray(productInventory)
    ? productInventory.filter(
      item =>
        item.segments !== null &&
        item.segments.some(segment => segment.inventory_available)
    )
    : [];

  const updateFloatingDropdownPosition = (element) => {
    if (!element) return;

    const rect = element.getBoundingClientRect();
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const dropdownWidth = Math.min(380, Math.max(300, rect.width + 120));
    const left = Math.min(Math.max(12, rect.left), viewportWidth - dropdownWidth - 12);

    setFloatingDropdownStyle({
      top: rect.bottom + 8,
      left,
      width: dropdownWidth,
    });
  };

  const closeFloatingDropdown = () => {
    setFloatingDropdownStyle(null);
  };

  const handleSearch = (index, query) => {
    setSearchQuery(query);

    let results = [];

    if (!query) {
      results = filteredInventory.slice(0, 10);
    } else {
      results = filteredInventory.filter(item =>
        item.title.toLowerCase().includes(query.toLowerCase())
      );
    }

    results = results.filter(item =>
      item.segments?.some(segment => segment.total_pc_in_uom === 1)
    );

    const uniqueTitles = new Set();
    results = results.filter(item => {
      if (uniqueTitles.has(item.title)) {
        return false;
      }
      uniqueTitles.add(item.title);
      return true;
    });

    setSearchResults(results);
  };

  const fetchSearchResults = async ({ page = 1, query = "", sort = "" } = {}) => {
    try {
      setLoading(true);

      const response = await PostPaginatedData("getProductAndInventory", {
        page,
        search: query || undefined,
        queryParams: {
          ...(sort && { sort }),
        }
      });
      const results = response?.data || [];

      const uniqueProducts = results
        .filter(item => item.segments && item.segments.some(segment => segment.inventory_available && segment.total_pc_in_uom === 1))
        .filter((item, idx, arr) => arr.findIndex(i => i.title === item.title) === idx);

      setSearchResults(uniqueProducts);
      setTotalCount(response?.data?.totalCount || 0);
      setTotalPages(Math.ceil((response?.data?.totalCount || 0) / 10));
      setCurrentPage(page);
      return { data: uniqueProducts, totalPages: Math.ceil((response?.data?.totalCount || 0) / 10) };
    } catch (error) {
      setSearchResults([]);
      setTotalCount(0);
      setTotalPages(1);
      setCurrentPage(1);
      return { data: [], totalPages: 1 };
    } finally {
      setLoading(false);
    }
  };


  const handleSelectProduct = (index, product) => {

    const existingProductIndex = products.findIndex(
      (prod, idx) =>
        idx !== index &&
        prod.product_inventory === product.id
    );

    if (existingProductIndex !== -1) {

      const updatedProducts = [...products];
      const existingProduct = updatedProducts[existingProductIndex];
      existingProduct.qty += 1;
      existingProduct.sold_qty_stock += 1;

      const amount = existingProduct.selling_price * existingProduct.qty;
      const discount = (amount * existingProduct.discount_percentage) / 100;
      const total = amount - discount;

      existingProduct.amount = amount;
      existingProduct.total = total;

      if (!updatedProducts[index].product_inventory) {
        updatedProducts[index] = {
          store: storeId,
          barcode: "",
          segment_barcode: "",
          additional_discount_value: "0",
          title: "",
          qty: 0,
          discount: 0,
          discount_percentage: 0,
          selling_price: 0,
          uom: "",
          uom_title: "",
          total_pc_in_uom: 0,
          amount: 0,
          total: 0,
          sold_qty_stock: 0,
          product_inventory: "",
          roundOff: 0,
        };
      }

      setProducts(updatedProducts);
      setSearchResults([]);
      setSearchQuery("");
      setFocusedIndex(null);
      closeFloatingDropdown();

      handleToast({
        type: 'SUCCESS',
        message: `Quantity updated for "${product.title}"!`
      });

      return;
    } const updatedProducts = [...products];
    const wasEmpty = !updatedProducts[index].product_inventory;

    const firstSegment = product.segments?.[0];

    if (!firstSegment || !firstSegment.uom) {
      handleToast({
        type: 'ERROR',
        message: `Missing UOM data for product: ${product.title}`
      });
      return;
    }

    const firstUom = firstSegment.uom;
    const uomTitle = firstSegment.uom_title || firstUom;
    const sellingPrice = parseFloat(firstSegment.selling_price) || 0;
    const total_pc_in_uom = firstSegment.total_pc_in_uom || 1;

    updatedProducts[index] = {
      ...updatedProducts[index],
      store: storeId,
      title: product.title,
      barcode: product.barcode || "",
      segment_barcode: firstSegment.segment_barcode || "",
      product_inventory: product.id,
      selling_price: sellingPrice,
      uom: firstUom,
      uom_title: uomTitle,
      total_pc_in_uom: total_pc_in_uom,
      discount_percentage: product.discount_percentage || 0,
      qty: 1,
      sold_qty_stock: 1,
      additional_discount_value: "0",
      roundOff: 0,
    };

    const amount = sellingPrice * updatedProducts[index].qty;
    const discount = (amount * updatedProducts[index].discount_percentage) / 100;
    const total = amount - discount;

    updatedProducts[index].amount = amount;
    updatedProducts[index].total = total;

    if (wasEmpty) {
      updatedProducts.push({
        store: storeId,
        barcode: "",
        segment_barcode: "",
        additional_discount_value: "0",
        title: "",
        qty: 0,
        discount: 0,
        discount_percentage: 0,
        selling_price: 0,
        uom: "",
        uom_title: "",
        total_pc_in_uom: 0,
        amount: 0,
        total: 0,
        sold_qty_stock: 0,
        product_inventory: "",
        roundOff: 0,
      });
    }

    setProducts(updatedProducts);
    setSearchResults([]);
    setSearchQuery("");
    setFocusedIndex(null);
    closeFloatingDropdown();

    handleToast({
      type: 'SUCCESS',
      message: `Product "${product.title}" added successfully!`
    });
  };

  const debounceRef = useRef(null);
  useEffect(() => {
    if (!searchQuery) return;
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      fetchProductsUnified({ page: 1, query: searchQuery, mode: "search" });
    }, 300);
    return () => clearTimeout(debounceRef.current);
  }, [searchQuery]);

  useEffect(() => {
    if (focusedIndex === null) return;

    const handleWindowChange = () => {
      closeFloatingDropdown();
      setFocusedIndex(null);
      setSearchResults([]);
      setSearchQuery("");
      setIsSearching(false);
    };

    window.addEventListener("resize", handleWindowChange);
    window.addEventListener("scroll", handleWindowChange, true);

    return () => {
      window.removeEventListener("resize", handleWindowChange);
      window.removeEventListener("scroll", handleWindowChange, true);
    };
  }, [focusedIndex]);

  useEffect(() => {
    setActiveButton(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    fetchProductsUnified({ page: 1, mode: "list" });
  }, []);

  const handleBarcodeInputChange = (e) => {
    setBarcodeInput(e.target.value);
    setIsUserActive(true);
    setActiveField("barcode");
  };

  const handleInputChange = (index, field, value) => {
    const updatedProducts = [...products];
    const parsedValue = parseFloat(value) || 0;
    updatedProducts[index][field] = parsedValue;

    if (field === "qty") {
      updatedProducts[index].qty = parsedValue;
      updatedProducts[index].sold_qty_stock = parsedValue;
    } else if (field === "discount") {
      updatedProducts[index].discount_percentage = parsedValue;
    } else if (field === "selling_price") {
      updatedProducts[index].selling_price = parsedValue;
    }

    const selling_price = parseFloat(updatedProducts[index].selling_price) || 0;
    const qty = updatedProducts[index].qty || 0;
    const discount =
      parseFloat(updatedProducts[index].discount_percentage) || 0;

    const amount = selling_price * qty;
    const total = amount - (amount * discount) / 100;

    updatedProducts[index].amount = amount;
    updatedProducts[index].total = total;

    setProducts(updatedProducts);
  };

  const handleDeleteRow = (indexToRemove) => {
    if (
      indexToRemove === products.length - 1 &&
      !products[indexToRemove].product_inventory
    ) {

      return;
    }
    const updatedProducts = products.filter(
      (_, index) => index !== indexToRemove
    );
    setProducts(updatedProducts);
  };

  const handleBarcodeBlur = async (page = 1, search = "") => {
    setIsUserActive(true);
    setActiveField(null);

    const barcodeInputValue = barcodeInput.trim();
    if (!barcodeInputValue) return;

    try {
      let foundProduct = null;
      let matchingSegment = null;

      let apiUrl = `${getAPI("getProductAndInventory")}?page=1`;

      if (search || barcodeInputValue) {
        apiUrl += `&search=${encodeURIComponent(barcodeInputValue)}`;
      }

      while (apiUrl && !foundProduct) {
        const response = await Post(apiUrl, {});
        const productList = response?.data?.results || [];

        for (const product of productList) {

          if (product.barcode === barcodeInputValue) {

            const unitSegment = product.segments?.find(
              segment => segment.total_pc_in_uom === 1
            );
            if (unitSegment) {
              foundProduct = product;
              matchingSegment = unitSegment;
              break;
            }
          }

          if (!foundProduct && product.segments) {
            const segmentMatch = product.segments.find(
              segment => segment.segment_barcode === barcodeInputValue
            );

            if (segmentMatch) {

              if (segmentMatch.total_pc_in_uom === 1) {
                foundProduct = product;
                matchingSegment = segmentMatch;
                break;
              } else {

                handleToast({
                  type: "ERROR",
                  message: `This barcode is for ${segmentMatch.uom_title} (${segmentMatch.total_pc_in_uom} pieces). Only single piece items can be added via barcode.`
                });
                setBarcodeInput("");
                return;
              }
            }
          }
        }

        apiUrl = foundProduct ? null : response?.data?.next;
      }

      if (!foundProduct || !matchingSegment) {
        handleToast({
          type: "ERROR",
          message: "No valid single-piece product found for the given barcode."
        });
        setBarcodeInput("");
        return;
      }

      if (!matchingSegment.inventory_available) {
        handleToast({
          type: "ERROR",
          message: `Product "${foundProduct.title}" is out of stock.`
        });
        setBarcodeInput("");
        return;
      }

      const uomTitle = matchingSegment.uom_title || matchingSegment.uom || "";
      const sellingPrice = parseFloat(matchingSegment.selling_price || 0);
      const total_pc_in_uom = matchingSegment.total_pc_in_uom || 0;

      const existingProductIndex = products.findIndex(
        (product) =>
          product.product_inventory === foundProduct.id &&
          product.uom === matchingSegment.uom
      );
      const updatedProducts = [...products];
      if (existingProductIndex !== -1) {

        const existingProduct = updatedProducts[existingProductIndex];
        existingProduct.qty += 1;
        existingProduct.sold_qty_stock += 1;
        existingProduct.amount = existingProduct.qty * sellingPrice;
        existingProduct.total = existingProduct.amount;
        existingProduct.uom_title = uomTitle;
        existingProduct.uom = matchingSegment.uom;
        existingProduct.total_pc_in_uom = total_pc_in_uom;
      } else {

        const newProduct = {
          store: storeId,
          barcode: foundProduct.barcode || "",
          segment_barcode: matchingSegment.segment_barcode || "",
          additional_discount_value: "0",
          title: foundProduct.title || "",
          qty: 1,
          discount: 0,
          discount_percentage: 0,
          selling_price: sellingPrice,
          uom: matchingSegment.uom,
          uom_title: uomTitle,
          total_pc_in_uom: total_pc_in_uom,
          amount: sellingPrice,
          total: sellingPrice,
          sold_qty_stock: 1,
          product_inventory: foundProduct.id || "",
          roundOff: 0,
        };
        const lastProduct = updatedProducts[updatedProducts.length - 1];

        if (!lastProduct || lastProduct.product_inventory) {
          updatedProducts.push(newProduct);
        } else {
          updatedProducts[updatedProducts.length - 1] = newProduct;
        }

        const emptyRow = {
          store: storeId,
          barcode: "",
          segment_barcode: "",
          additional_discount_value: "0",
          title: "",
          qty: 0,
          discount: 0,
          discount_percentage: 0,
          selling_price: 0,
          uom: "",
          uom_title: "",
          total_pc_in_uom: 0,
          amount: 0,
          total: 0,
          sold_qty_stock: 0,
          product_inventory: "",
          roundOff: 0,
        };
        updatedProducts.push(emptyRow);
      }

      setProducts(updatedProducts);
      setBarcodeInput("");

      handleToast({
        type: "SUCCESS",
        message: `Product "${foundProduct.title}" (${uomTitle}) processed successfully!`
      });
    } catch (error) {
      console.error("Error fetching product data:", error);
      handleToast({
        type: "ERROR",
        message: "Failed to fetch product details. Please check the barcode."
      });
      setBarcodeInput("");
    }
  };


  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleRoundOffChange = (e) => {
    setRoundOffEnabled(e.target.value === "yes");
  };
  const calculateRoundOff = (totalDiscounted) => {
    const decimalPart =
      Math.round((totalDiscounted - Math.floor(totalDiscounted)) * 100) / 100;
    const roundedValue =
      decimalPart >= 0.5
        ? Math.ceil(totalDiscounted)
        : Math.floor(totalDiscounted);
    const roundOff = Math.round((roundedValue - totalDiscounted) * 100) / 100;

    return { roundedValue, roundOff };
  };

  const calculateTotals = (products) => {
    let totalQty = 0;
    let totalAmount = 0;
    let totalDiscounted = 0;
    let totalDiscount = 0;
    let totalRate = 0;
    const uniquePer = new Set();
    let discountRowCount = 0;

    products.forEach((product) => {
      totalQty += parseFloat(product.qty) || 0;
      totalAmount += parseFloat(product.amount) || 0;
      totalDiscounted += parseFloat(product.total) || 0;
      totalRate += parseFloat(product.selling_price) || 0;

      if (
        product.discount !== undefined &&
        !isNaN(parseFloat(product.discount))
      ) {
        totalDiscount += parseFloat(product.discount) || 0;
        discountRowCount++;
      }

      if (product.per) {
        uniquePer.add(product.per);
      }
    });

    totalDiscount = discountRowCount > 0 ? totalDiscount / discountRowCount : 0;

    const { roundedValue, roundOff } = calculateRoundOff(totalDiscounted);

    return {
      totalQty,
      totalAmount,
      totalDiscounted,
      totalDiscount,
      totalRate,
      uniquePer: Array.from(uniquePer),
      roundedValue,
      roundOff,
    };
  };

  const totals = calculateTotals(products);
  const {
    totalQty,
    totalAmount,
    totalDiscounted,

    totalRate,
    uniquePer,
    roundedValue,

  } = totals;

  const finalPayableAmount = roundOffEnabled
    ? roundedValue - additionalDiscount
    : totalDiscounted - additionalDiscount;

  const fetchProductsUnified = async ({
    page = 1,
    query = "",
    mode = "list",
  } = {}) => {
    try {
      setLoading(true);

      const apiUrl = `${getAPI("getProductAndInventory")}?page=${page}${query ? `&search=${encodeURIComponent(query)}` : ""
        }`;
    

      const response = await Post(apiUrl);

      const results = response?.data?.results || [];

      const filtered = results
        .filter(item =>
          item.segments?.some(
            s => s.inventory_available && s.total_pc_in_uom === 1
          )
        )
        .filter(
          (item, i, arr) =>
            arr.findIndex(x => x.title === item.title) === i
        );

      if (mode === "search") {
        setSearchResults(filtered);
      } else {
        setProductInventory(filtered);
      }

      setTotalCount(response?.data?.count || 0);
      setTotalPages(
        Math.ceil((response?.data?.count || 0) / itemsPerPage)
      );
      setCurrentPage(page);

      if (mode === "list" && filtered.length > 0) {
        const nextInvoiceNo = filtered[0].next_invoice_no;
        const currentDate = new Date().toISOString().split("T")[0];

        setFormData(prev => ({
          ...prev,
          invoice_no: nextInvoiceNo,
          note: `Date: ${currentDate}, Invoice No: ${nextInvoiceNo}`,
        }));
      }
    } catch (err) {
      console.error(err);

      if (mode === "search") {
        setSearchResults([]);
      } else {
        setProductInventory([]);
      }
    } finally {
      setLoading(false);
    }
  };

  const triggerCashDrawerPop = async () => {
    try {
      const drawers = await Get(`${getAPI('posCashDrawers')}?store_id=${storeId}`);
      const defaultDrawer = drawers?.find(d => d.is_default || d.enabled) || drawers?.[0];
      if (!defaultDrawer) return;

      if (defaultDrawer.connection_type === "PRINTER_DRIVEN" && defaultDrawer.printer_id) {
        const printers = await Get(`${getAPI('posPrinters')}?store_id=${storeId}`);
        const linkedPrinter = printers?.find(p => p.id === defaultDrawer.printer_id);
        if (linkedPrinter && linkedPrinter.connection_type === "NETWORK") {
          const kickUrl = `http://${linkedPrinter.ip_address}:${linkedPrinter.port || 9100}/kick-drawer`;
          await fetch(kickUrl, { method: "POST", mode: "no-cors" });
        }
      } else if (defaultDrawer.connection_type === "SERIAL" || defaultDrawer.connection_type === "USB") {
        if (defaultDrawer.ip_address) {
          const kickUrl = `http://${defaultDrawer.ip_address}:${defaultDrawer.port || 9100}/kick-drawer`;
          await fetch(kickUrl, { method: "POST", mode: "no-cors" });
        }
      }
    } catch (err) {
      console.warn("Auto drawer kick failed:", err);
    }
  };

  const pollTerminalPayment = (paymentId, payload, openModal) => {
    let attempts = 0;
    if (pollingRef.current) clearInterval(pollingRef.current);
    
    pollingRef.current = setInterval(() => {
      attempts += 1;
      if (attempts > 60) {
        clearInterval(pollingRef.current);
        setTerminalStatus("FAILED");
        setTerminalMessage("Payment timeout. Please try again.");
        return;
      }

      Get(`${getAPI('paymentsTerminal')}${paymentId}/`)
        .then((response) => {
          const status = response.status;
          setTerminalStatus(status);
          if (status === "WAITING_FOR_CUSTOMER") {
            setTerminalMessage(`Please tap, insert, or swipe your card on ${selectedTerminal?.name || "the terminal"}...`);
          } else if (status === "PROCESSING") {
            setTerminalMessage("Processing card payment. Please wait...");
          } else if (status === "SUCCESS") {
            clearInterval(pollingRef.current);
            setTerminalMessage("Payment approved! Finalizing invoice...");
            
            const updatedPayload = {
              ...payload,
              sales_invoice: {
                ...payload.sales_invoice,
                pay_method: "bank",
                note: `${payload.sales_invoice.note || ""} (Terminal Ref: ${response.payment_reference})`.trim()
              }
            };
            
            Post("createSalesInvoice", updatedPayload)
              .then((invoiceRes) => {
                handleToast({ type: "SUCCESS", message: "Invoice billed successfully via Terminal!" });
                if (openModal) {
                  setModalData(invoiceRes.data);
                  setShowInvoice(true);
                }
                resetInvoiceFields();
              })
              .catch((err) => {
                handleToast({ type: "ERROR", message: "Failed to finalize invoice database record." });
              })
              .finally(() => {
                setShowTerminalModal(false);
              });
          }
        })
        .catch((err) => {
          console.error("Error checking terminal status:", err);
        });
    }, 3000);
  };

  const resetInvoiceFields = () => {
    setFormData({
      store: storeId,
      date: new Date().toISOString().split("T")[0],
      customer: "",
      invoice_no: "",
      pay_method: "cash",
      additional_discount_value: "0",
      cheque_no: "",
      bank: "",
      note: "",
      total: "",
      round_off: "0",
    });
    setProducts([
      {
        store: storeId,
        barcode: "",
        additional_discount_value: "0",
        title: "",
        qty: 0,
        discount: 0,
        discount_percentage: 0,
        selling_price: 0,
        uom: "",
        amount: 0,
        total: 0,
        sold_qty_stock: 0,
        product_inventory: "",
        roundOff: 0,
      },
    ]);
  };

  const handleSubmit = async (openModal = false) => {
    try {
      const payMethodMapping = {
        bank: "bank",
        cheque: "cheque",
        cash: "cash",
        terminal: "terminal"
      };
      if (!formData.invoice_no) {
        handleToast({
          type: 'ERROR',
          message: "Invoice number is required!"
        })
        return;
      }
      const filteredProducts = products.filter(
        (product) =>
          product.product_inventory &&
          product.qty &&
          parseFloat(product.qty) > 0
      );
      if (filteredProducts.length === 0) {
        handleToast({
          type: 'ERROR',
          message: "At least one valid product is required!"
        })
        return;
      }
      if (!shiftData?.is_active) {
        // No point sending this to the backend just to get a "no active
        // shift" error back - catch it here and let the user start a shift
        // right from this popup, then continue with the same sale.
        setPendingSubmitOpenModal(openModal);
        setShowShiftRequiredModal(true);
        return;
      }
      for (const product of filteredProducts) {
        if (!product.product_inventory) {
          handleToast({
            type: 'ERROR',
            message: `Invalid product found in the list. Please check your products.`
          })
          return;
        }
        if (!product.qty || product.qty <= 0) {
          handleToast({
            type: 'ERROR',
            message: `Quantity must be greater than 0 for ${product.title || "product"}`
          })
          return;
        }
        if (!product.uom || !product.total_pc_in_uom) {
          handleToast({
            type: 'ERROR',
            message: `Unit of measure is required for ${product.title || "product"}`
          })
          return;
        }

        const amount = parseFloat(product.amount) || 0;
        const discountPercentage = parseFloat(product.discount_percentage) || 0;
        const discountAmount = (discountPercentage / 100) * amount;
        const afterDiscountPrice = amount - discountAmount;

        if (afterDiscountPrice < 0) {
          handleToast({
            type: 'ERROR',
            message: `Invalid discount for ${product.title || "product"
              }. Discount cannot exceed total amount.`
          })
          return;
        }
      }

      const subTotal = filteredProducts.reduce(
        (sum, product) => sum + (parseFloat(product.amount) || 0),
        0
      );

      const totalDiscount = filteredProducts.reduce((sum, product) => {
        const amount = parseFloat(product.amount) || 0;
        const discountPercentage = parseFloat(product.discount_percentage) || 0;
        return sum + (amount * discountPercentage) / 100;
      }, 0);

      const additionalDiscountValue =
        parseFloat(formData.additional_discount_value) || 0;
      const totalAfterProductDiscount = subTotal - totalDiscount;
      const additionalDiscountAmount =
        (additionalDiscountValue / 100) * totalAfterProductDiscount;

      const totalBeforeRoundOff =
        totalAfterProductDiscount - additionalDiscountAmount;
      const roundedTotal = roundOffEnabled
        ? Math.round(totalBeforeRoundOff)
        : totalBeforeRoundOff;
      const roundOffAmount = roundOffEnabled
        ? roundedTotal - totalBeforeRoundOff
        : 0;

      const payload = {
        sales_invoice: {
          store: formData.store,
          customer: formData.customer || "",
          date: formData.date,
          invoice_no: formData.invoice_no,
          pay_method:
            payMethodMapping[formData.pay_method] || formData.pay_method,
          additional_discount_value: additionalDiscountValue.toString(),
          cheque_no: formData.cheque_no || "",
          bank: formData.bank || "",
          note: formData.note || "",
          round_off: roundOffAmount.toFixed(2),
          payable_amount: roundedTotal.toFixed(2),
          sub_total: subTotal.toFixed(2),
          total_discount: totalDiscount.toFixed(2),
          final_total_amount: totalAfterProductDiscount.toFixed(2),
          final_after_discount: totalBeforeRoundOff.toFixed(2),
          invoice_type: formData.invoice_type || "retail",
        },
        sales_invoice_products: filteredProducts.map((product) => ({
          store: formData.store,
          product: product.product_inventory,
          sold_qty_stock: parseFloat(product.qty),
          discount_percentage: parseFloat(product.discount_percentage) || 0,
          uom: product.uom,
          total_pc_in_uom: parseFloat(product.total_pc_in_uom),
          amount: parseFloat(product.amount).toFixed(2),
          total: parseFloat(product.total).toFixed(2),
          selling_price: parseFloat(product.selling_price).toFixed(2),
          total_amount: (
            parseFloat(product.selling_price) * parseFloat(product.qty)
          ).toFixed(2),
          after_discount: (
            parseFloat(product.total) *
            (1 - (parseFloat(product.discount_percentage) || 0) / 100)
          ).toFixed(2),
        })),
        inventory_clearance_pattern: "FIFO",
      };

      if (formData.pay_method === "terminal") {
        if (!selectedTerminal) {
          handleToast({ type: "ERROR", message: "Please configure a payment terminal in Settings first." });
          return;
        }
        setShowTerminalModal(true);
        setTerminalStatus("CONNECTING");
        setTerminalMessage(`Connecting to ${selectedTerminal.name}...`);
        
        Post("paymentsTerminal", {
          store_id: storeId,
          terminal_id: selectedTerminal.id,
          amount_minor: Math.round(roundedTotal * 100)
        })
          .then((response) => {
            const data = response.data;
            pollTerminalPayment(data.payment_id, payload, openModal);
          })
          .catch((err) => {
            console.error("Error initiating payment:", err);
            setTerminalStatus("FAILED");
            setTerminalMessage(err.response?.data?.detail || "Failed to initiate payment on terminal.");
          });
        return;
      }

      const response = await Post("createSalesInvoice", payload);

      if (response && response.data) {
        if (formData.pay_method === "cash") {
          triggerCashDrawerPop();
        }

        handleToast({
          type: 'SUCCESS',
          message: "Sales invoice created successfully!"
        })

        if (openModal) {
          setModalData(response.data);
          setShowInvoice(true);
        }

        setFormData({
          store: storeId,
          date: new Date().toISOString().split("T")[0],
          customer: "",
          invoice_no: "",
          pay_method: "cash",
          additional_discount_value: "0",
          cheque_no: "",
          bank: "",
          note: "",
          total: "",
          round_off: "0",
        });

        setProducts([
          {
            store: storeId,
            barcode: "",
            segment_barcode: "",
            additional_discount_value: "0",
            title: "",
            qty: 0,
            discount: 0,
            discount_percentage: 0,
            selling_price: 0,
            uom: "",
            uom_title: "",
            total_pc_in_uom: 0,
            amount: 0,
            total: 0,
            sold_qty_stock: 0,
            product_inventory: "",
            roundOff: 0,
          },
        ]);

        setAdditionalDiscount("0");
        setRoundOffAmount(0);
        setBarcodeInput("");

        await fetchProductsUnified();
      }
    } catch (error) {
      console.error("Error creating sales invoice:", error);

      if (error.response?.data?.error) {

        handleToast({
          type: 'ERROR',
          message: error?.response?.data?.error || "Something went wrong. Please try again."
        })
      } else if (error.response?.data?.message) {

        handleToast({
          type: 'ERROR',
          message: error?.response?.data?.error || "Something went wrong. Please try again."
        })
      } else {

        handleToast({
          type: 'ERROR',
          message: "Failed to create sales invoice. Please try again."
        })
      }
    }
  };

  const handleStartShiftAndContinueSale = async () => {
    setStartingShiftForSale(true);
    try {
      const result = await startShift();
      if (result?.success) {
        setShowShiftRequiredModal(false);
        handleToast({ type: "SUCCESS", message: "Shift started." });
        // Re-run the same sale now that a shift is active.
        handleSubmit(pendingSubmitOpenModal);
      } else {
        handleToast({ type: "ERROR", message: result?.error || "Could not start shift. Please try again." });
      }
    } catch (err) {
      console.error("Error starting shift from sale:", err);
      handleToast({ type: "ERROR", message: "Could not start shift. Please try again." });
    } finally {
      setStartingShiftForSale(false);
    }
  };

  const handlePrint = async (invoiceId, openModal = false) => {
    try {

      const response = await Post("getSalesInvoiceDetails", {
        invoice_id: invoiceId,
      });

      if (response?.data && openModal) {
        setModalData(response.data);
        setShowInvoice(true);
      } else {
        console.error("Invalid API response:", response);
      }
    } catch (error) {
      console.error("Error fetching invoice details:", error);
    }
  };

  return (
    <div className="responsive-box qinv-page">
      <ToastContainer />

      <style>
        {`
          .qinv-page {
            min-height: 100vh;
            background:
              radial-gradient(circle at top left, rgba(14, 116, 144, 0.10), transparent 30%),
              radial-gradient(circle at top right, rgba(22, 163, 74, 0.08), transparent 28%),
              linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
            padding: 10px 12px 28px;
            color: #0f172a;
          }
          .qinv-shell { max-width: 1240px; margin: 0 auto; }
          .qinv-hero {
            background: linear-gradient(135deg, #020617 0%, #0f172a 58%, #075985 100%);
            color: #fff; border-radius: 24px; padding: 18px 20px;
            box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18);
            display: flex; align-items: center; justify-content: space-between;
            gap: 18px; flex-wrap: wrap; margin-bottom: 14px; position: relative; overflow: hidden;
          }
          .qinv-hero::after {
            content: ""; position: absolute; width: 240px; height: 240px; border-radius: 999px;
            right: -90px; top: -130px; background: rgba(56, 189, 248, 0.16);
          }
          .qinv-hero-content, .qinv-hero-stats { position: relative; z-index: 1; }
          .qinv-kicker {
            display: inline-flex; align-items: center; gap: 8px;
            background: rgba(255,255,255,0.13); border: 1px solid rgba(255,255,255,0.22);
            color: #e0f2fe; padding: 6px 11px; border-radius: 999px;
            font-size: 11px; font-weight: 950; margin-bottom: 8px;
          }
          .qinv-kicker-dot {
            width: 7px; height: 7px; border-radius: 999px; background: #22c55e;
            box-shadow: 0 0 0 4px rgba(34,197,94,0.16);
          }
          .qinv-title { margin: 0; font-size: 27px; font-weight: 950; letter-spacing: -0.04em; line-height: 1.1; }
          .qinv-subtitle { margin: 6px 0 0; color: rgba(255,255,255,0.78); font-size: 12px; font-weight: 700; }
          .qinv-hero-stats { display: flex; gap: 10px; flex-wrap: wrap; }
          .qinv-stat-card {
            min-width: 132px; background: rgba(255,255,255,0.12); border: 1px solid rgba(255,255,255,0.22);
            border-radius: 18px; padding: 11px 13px; backdrop-filter: blur(10px);
          }
          .qinv-stat-label {
            font-size: 10px; font-weight: 900; text-transform: uppercase;
            letter-spacing: 0.06em; color: rgba(255,255,255,0.66);
          }
          .qinv-stat-value { margin-top: 4px; font-size: 18px; font-weight: 950; color: #fff; }
          .qinv-top-panel {
            background: rgba(255,255,255,0.94); border: 1px solid #dbe3ec; border-radius: 22px;
            padding: 15px; box-shadow: 0 14px 36px rgba(15,23,42,0.07); margin-bottom: 14px;
          }
          .qinv-field-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
          .qinv-field-card {
            border: 1px solid #dbe3ec; background: #fff; border-radius: 18px; padding: 12px;
            display: flex; align-items: center; gap: 11px; min-width: 0;
          }
          .qinv-field-icon {
            width: 40px; height: 40px; border-radius: 14px; background: #eff6ff;
            border: 1px solid #bfdbfe; display: flex; align-items: center; justify-content: center; flex-shrink: 0;
          }
          .qinv-field-icon img { width: 22px; height: 22px; object-fit: contain; }
          .qinv-field-body { min-width: 0; flex: 1; }
          .qinv-label {
            display: block; margin-bottom: 6px; color: #475569; font-size: 11px;
            font-weight: 950; text-transform: uppercase; letter-spacing: 0.04em;
          }
          .qinv-input, .qinv-page .form-control-invoice {
            width: 100% !important; height: 39px !important; border: 1px solid #cbd5e1 !important;
            border-radius: 13px !important; background: #fff !important; color: #0f172a !important;
            font-size: 13px !important; font-weight: 800 !important; padding: 0 12px !important;
            outline: none !important; box-shadow: none !important; transition: border .18s ease, box-shadow .18s ease;
          }
          .qinv-input:focus, .qinv-page .form-control-invoice:focus {
            border-color: #0284c7 !important; box-shadow: 0 0 0 4px rgba(2,132,199,0.12) !important;
          }
          .qinv-readonly { background: #f8fafc !important; color: #334155 !important; }
          .qinv-billing-card {
            background: #fff; border: 1px solid #dbe3ec; border-radius: 24px;
            box-shadow: 0 16px 42px rgba(15,23,42,0.075); overflow: visible;
          }
          .qinv-card-header {
            padding: 15px 16px; border-bottom: 1px solid #e2e8f0;
            display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap;
          }
          .qinv-section-title { margin: 0; color: #0f172a; font-size: 18px; font-weight: 950; letter-spacing: -0.025em; }
          .qinv-section-subtitle { margin: 3px 0 0; color: #64748b; font-size: 12px; font-weight: 750; }
          .qinv-badge {
            border-radius: 999px; padding: 7px 10px; background: #ecfdf5; border: 1px solid #86efac;
            color: #166534; font-size: 11px; font-weight: 950; white-space: nowrap;
          }
          .qinv-table-wrap { overflow: visible; padding: 0 12px 18px; position: relative; z-index: 21; }
          .qinv-table { width: 100%; min-width: 900px; border-collapse: separate; border-spacing: 0 8px; position: relative; z-index: 22; }
          .qinv-product-row.qinv-row-focused { position: relative; z-index: 500; }
          .qinv-product-row.qinv-row-focused td { position: relative; z-index: 501; }
          .qinv-product-row.qinv-row-focused .qinv-product-search-cell { z-index: 900; }
          .qinv-total-row { position: relative; z-index: 1; }
          .qinv-table thead th {
            padding: 12px 10px; color: #475569; font-size: 11px; font-weight: 950;
            text-transform: uppercase; letter-spacing: .055em; background: #f8fafc;
            border-top: 1px solid #e2e8f0; border-bottom: 1px solid #e2e8f0; text-align: center;
          }
          .qinv-table thead th:first-child { border-left: 1px solid #e2e8f0; border-radius: 14px 0 0 14px; }
          .qinv-table thead th:last-child { border-right: 1px solid #e2e8f0; border-radius: 0 14px 14px 0; }
          .qinv-table tbody tr.qinv-product-row {
            position: relative;
            background: #fff; box-shadow: 0 7px 20px rgba(15,23,42,0.055);
            transition: transform .16s ease, box-shadow .16s ease;
          }
          .qinv-table tbody tr.qinv-product-row:hover { transform: translateY(-1px); box-shadow: 0 12px 26px rgba(15,23,42,0.10); }
          .qinv-table tbody td {
            padding: 9px 8px; border-top: 1px solid #e2e8f0; border-bottom: 1px solid #e2e8f0;
            text-align: center; vertical-align: middle; position: relative;
          }
          .qinv-table tbody td:first-child { border-left: 1px solid #e2e8f0; border-radius: 15px 0 0 15px; }
          .qinv-table tbody td:last-child { border-right: 1px solid #e2e8f0; border-radius: 0 15px 15px 0; }
          .qinv-sr-pill {
            display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px;
            border-radius: 12px; background: #eff6ff; color: #075985; font-size: 12px; font-weight: 950;
          }
          .qinv-cell-input, .qinv-page .field {
            width: 100%; min-width: 86px; height: 36px; border: 1px solid #dbe3ec !important;
            border-radius: 12px; background: #fff !important; color: #0f172a !important;
            font-size: 13px; font-weight: 850; text-align: center; outline: none; padding: 0 10px;
            transition: border .18s ease, box-shadow .18s ease;
          }
          .qinv-cell-input:focus, .qinv-page .field:focus { border-color: #0284c7 !important; box-shadow: 0 0 0 4px rgba(2,132,199,0.11); }
          .qinv-cell-input-readonly { background: #f8fafc !important; color: #334155 !important; }
          .qinv-product-search-cell { position: relative; min-width: 220px; }
          .qinv-search-results {
            position: fixed;
            max-height: 340px;
            overflow-y: auto;
            list-style: none;
            margin: 0;
            padding: 7px;
            border-radius: 18px;
            background: #ffffff;
            border: 1px solid #cbd5e1;
            box-shadow:
              0 32px 80px rgba(15, 23, 42, 0.30),
              0 0 0 4px rgba(255, 255, 255, 0.88);
            z-index: 2147483000;
            overscroll-behavior: contain;
          }

          .qinv-search-results::-webkit-scrollbar {
            width: 8px;
          }

          .qinv-search-results::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 999px;
          }

          .qinv-search-results::-webkit-scrollbar-track {
            background: #f8fafc;
            border-radius: 999px;
          }
          .qinv-search-item {
            padding: 10px 11px; border-radius: 12px; cursor: pointer; color: #0f172a;
            font-size: 13px; font-weight: 850; text-align: left; transition: background .16s ease, transform .16s ease;
          }
          .qinv-search-item:hover { background: #eff6ff; transform: translateX(2px); }
          .qinv-search-empty {
            position: fixed;
            padding: 12px;
            border-radius: 18px;
            background: #ffffff;
            border: 1px solid #cbd5e1;
            box-shadow:
              0 32px 80px rgba(15, 23, 42, 0.30),
              0 0 0 4px rgba(255, 255, 255, 0.88);
            z-index: 2147483000;
            color: #64748b;
            font-size: 12px;
            font-weight: 800;
            text-align: center;
          }
          .qinv-amount-cell { min-width: 140px; font-size: 14px; font-weight: 950; color: #064e3b; background: #f0fdf4; }
          .qinv-delete-btn {
            width: 31px; height: 31px; border: none; border-radius: 11px; background: #fee2e2;
            color: #991b1b; display: inline-flex; align-items: center; justify-content: center;
            cursor: pointer; margin-left: 8px; transition: transform .16s ease, background .16s ease;
          }
          .qinv-delete-btn:hover { transform: scale(1.05); background: #fecaca; }
          .qinv-total-row td { background: #fffbeb !important; border-color: #fde68a !important; font-size: 13px; font-weight: 950; color: #78350f; }
          .qinv-bottom-grid { display: grid; grid-template-columns: 1.1fr .9fr; gap: 14px; margin-top: 14px; align-items: start; position: relative; z-index: 5; }
          .qinv-panel {
            background: #fff; border: 1px solid #dbe3ec; border-radius: 22px;
            padding: 15px; box-shadow: 0 14px 36px rgba(15,23,42,0.065);
          }
          .qinv-payment-options {
            display: flex; gap: 8px; flex-wrap: wrap; padding: 5px; border: 1px solid #dbe3ec;
            border-radius: 999px; width: fit-content; background: #f8fafc;
          }
          .qinv-payment-chip {
            border: none; border-radius: 999px; padding: 9px 14px; background: transparent; color: #334155;
            font-size: 12px; font-weight: 950; cursor: pointer; transition: background .18s ease, color .18s ease, transform .18s ease;
          }
          .qinv-payment-chip:hover { transform: translateY(-1px); }
          .qinv-payment-chip.active { background: #075985; color: #fff; box-shadow: 0 8px 18px rgba(7,89,133,0.18); }
          .qinv-note {
            width: 100%; min-height: 86px; resize: vertical; border: 1px solid #dbe3ec;
            border-radius: 16px; background: #f8fafc; color: #334155; padding: 11px 12px;
            font-size: 13px; font-weight: 750; outline: none;
          }
          .qinv-summary-panel {
            background: radial-gradient(circle at top right, rgba(34,197,94,0.12), transparent 38%), #fff;
            border: 1px solid #bbf7d0;
          }
          .qinv-roundoff-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 13px; }
          .qinv-roundoff-toggle { display: inline-flex; border: 1px solid #cbd5e1; border-radius: 999px; padding: 4px; background: #fff; }
          .qinv-toggle-option {
            min-width: 58px; border-radius: 999px; padding: 7px 12px; text-align: center; cursor: pointer;
            color: #334155; font-size: 12px; font-weight: 950;
          }
          .qinv-toggle-option.active { background: #166534; color: #fff; }
          .qinv-summary-line {
            display: flex; align-items: center; justify-content: space-between; gap: 12px;
            padding: 9px 0; border-bottom: 1px dashed #cbd5e1; color: #334155; font-size: 13px; font-weight: 850;
          }
          .qinv-summary-line strong { color: #0f172a; font-size: 14px; font-weight: 950; }
          .qinv-payable-box {
            margin-top: 14px; border-radius: 20px; padding: 16px;
            background: linear-gradient(135deg, #064e3b 0%, #166534 100%);
            color: #fff; display: flex; align-items: center; justify-content: space-between; gap: 12px;
          }
          .qinv-payable-label {
            font-size: 12px; font-weight: 900; color: rgba(255,255,255,0.76);
            text-transform: uppercase; letter-spacing: .06em;
          }
          .qinv-payable-value { font-size: 26px; font-weight: 950; letter-spacing: -0.04em; }
          .qinv-actions { display: flex; justify-content: flex-end; gap: 11px; margin-top: 14px; flex-wrap: wrap; }
          .qinv-btn {
            border: none; border-radius: 999px; min-width: 165px; height: 45px; padding: 0 18px;
            font-size: 13px; font-weight: 950; cursor: pointer; transition: transform .18s ease, box-shadow .18s ease, background .18s ease;
          }
          .qinv-btn:hover { transform: translateY(-1px); }
          .qinv-btn-clear { background: #fff; color: #0f172a; border: 1px solid #94a3b8; }
          .qinv-btn-primary { background: #075985; color: #fff; box-shadow: 0 12px 24px rgba(7,89,133,0.20); }
          @media (max-width: 992px) {
            .qinv-table-wrap { overflow-x: auto; overflow-y: visible; padding-bottom: 80px; }
            .qinv-field-grid { grid-template-columns: 1fr; }
            .qinv-bottom-grid { grid-template-columns: 1fr; }
            .qinv-hero-stats { width: 100%; }
            .qinv-stat-card { flex: 1; min-width: 0; }
          }
          @media (max-width: 640px) {
            .qinv-page { padding: 8px 8px 22px; }
            .qinv-hero { border-radius: 20px; padding: 16px; }
            .qinv-title { font-size: 23px; }
            .qinv-payment-options { width: 100%; border-radius: 18px; }
            .qinv-payment-chip { flex: 1; }
            .qinv-actions { flex-direction: column; }
            .qinv-btn { width: 100%; }
            .qinv-payable-box { flex-direction: column; align-items: flex-start; }
          }
        `}
      </style>

      {showShiftRequiredModal && (
        <div
          role="dialog"
          aria-modal="true"
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.55)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            padding: "16px",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "16px",
              padding: "28px",
              maxWidth: "420px",
              width: "100%",
              textAlign: "center",
              boxShadow: "0 24px 60px rgba(15, 23, 42, 0.25)",
            }}
          >
            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "50%",
                background: "#eefbf2",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
                fontSize: "26px",
              }}
            >
              🕒
            </div>
            <h3 style={{ margin: "0 0 8px", fontSize: "18px", fontWeight: 850, color: "#0f172a" }}>
              Start a shift to make this sale
            </h3>
            <p style={{ margin: "0 0 22px", fontSize: "14px", color: "#64748b" }}>
              Sales can only be recorded while a shift is active. Start one now and this sale will go through right after.
            </p>
            <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
              <button
                type="button"
                onClick={() => setShowShiftRequiredModal(false)}
                disabled={startingShiftForSale}
                style={{
                  padding: "10px 20px",
                  borderRadius: "10px",
                  border: "1px solid #e2e8f0",
                  background: "#fff",
                  color: "#334155",
                  fontWeight: 700,
                  cursor: startingShiftForSale ? "not-allowed" : "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleStartShiftAndContinueSale}
                disabled={startingShiftForSale}
                style={{
                  padding: "10px 24px",
                  borderRadius: "10px",
                  border: "none",
                  background: startingShiftForSale ? "#94a3b8" : "#16a34a",
                  color: "#fff",
                  fontWeight: 800,
                  cursor: startingShiftForSale ? "not-allowed" : "pointer",
                }}
              >
                {startingShiftForSale ? "Starting Shift..." : "Start Shift & Sell"}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="qinv-shell">
        <div className="qinv-hero">
          <div className="qinv-hero-content">
            <div className="qinv-kicker">
              <span className="qinv-kicker-dot" />
              <span>{pageBadgeLabel}</span>
            </div>
            <h1 className="qinv-title">{pageTitle}</h1>
            <p className="qinv-subtitle">
              {pageSubtitle}
            </p>
          </div>

          <div className="qinv-hero-stats">
            <div className="qinv-stat-card">
              <div className="qinv-stat-label">Items</div>
              <div className="qinv-stat-value">{totalQty || 0}</div>
            </div>
            <div className="qinv-stat-card">
              <div className="qinv-stat-label">Subtotal</div>
              <div className="qinv-stat-value">{formatCurrency(Number(totalAmount || 0))}</div>
            </div>
            <div className="qinv-stat-card">
              <div className="qinv-stat-label">Payable</div>
              <div className="qinv-stat-value">
                {formatCurrency(typeof finalPayableAmount === "number" && !isNaN(finalPayableAmount)
                  ? finalPayableAmount
                  : 0)}
              </div>
            </div>
          </div>
        </div>

        <div className="qinv-top-panel">
          <div className="qinv-field-grid">
            <div className="qinv-field-card">
              <div className="qinv-field-icon">
                <span style={{ fontSize: "19px", fontWeight: 950, color: "#075985" }}>D</span>
              </div>
              <div className="qinv-field-body">
                <label className="qinv-label">Invoice Date</label>
                <CustomDateInput
                  value={formData.date}
                  onChange={handleFormChange}
                  required
                  className="form-control-invoice"
                  inputStyle={{ height: "39px" }}
                  showIcon={true}
                  readOnly
                  iconStyle={{ fontSize: "18px", color: "#075985" }}
                  style={{ width: "100%" }}
                />
              </div>
            </div>

            <div className="qinv-field-card">
              <div className="qinv-field-icon">
                <img src={scanner} alt="Barcode Icon" />
              </div>
              <div className="qinv-field-body">
                <label className="qinv-label">Barcode</label>
                <input
                  type="text"
                  className="qinv-input"
                  value={barcodeInput}
                  onChange={handleBarcodeInputChange}
                  onBlur={handleBarcodeBlur}
                  onFocus={() => setActiveField("barcode")}
                  placeholder="Scan or enter barcode"
                />
              </div>
            </div>

            <div className="qinv-field-card">
              <div className="qinv-field-icon">
                <img src={Invoice} alt="Invoice Icon" />
              </div>
              <div className="qinv-field-body">
                <label className="qinv-label">Invoice Number</label>
                <input
                  type="text"
                  id="invoiceNo"
                  name="invoice_no"
                  className="qinv-input qinv-readonly"
                  value={formData.invoice_no}
                  readOnly
                  onChange={handleFormChange}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="qinv-billing-card">
          <div className="qinv-card-header">
            <div>
              <h2 className="qinv-section-title">Product Billing</h2>
              <p className="qinv-section-subtitle">
                Search product name or scan barcode to add items quickly.
              </p>
            </div>
            <span className="qinv-badge">
              {products.filter((product) => product.product_inventory).length} Products Added
            </span>
          </div>

          <div className="qinv-table-wrap">
            <table className="qinv-table">
              <thead>
                <tr>
                  <th style={{ width: "70px" }}>Sr.</th>
                  <th style={{ width: "260px" }}>Product Name</th>
                  <th>Quantity</th>
                  <th>Rate</th>
                  <th>UOM</th>
                  <th>Amount</th>
                </tr>
              </thead>

              <tbody>
                {products.map((product, index) => (
                  <tr
                    className={`qinv-product-row ${focusedIndex === index ? "qinv-row-focused" : ""}`}
                    key={index}
                    onMouseEnter={() => setHoveredRowIndex(index)}
                    onMouseLeave={() => setHoveredRowIndex(null)}
                  >
                    <td>
                      <span className="qinv-sr-pill">{index + 1}</span>
                    </td>

                    <td className="qinv-product-search-cell">
                      <input
                        type="text"
                        placeholder="Search product"
                        className="qinv-cell-input"
                        value={focusedIndex === index ? searchQuery : products[index].title}
                        onChange={async (e) => {
                          setSearchQuery(e.target.value);
                          setFocusedIndex(index);
                          setIsSearching(true);
                          updateFloatingDropdownPosition(e.target);
                          clearTimeout(debounceRef.current);
                          debounceRef.current = setTimeout(() => {
                            fetchProductsUnified({ page: 1, query: e.target.value, mode: "search" });
                          }, 300);
                        }}
                        onFocus={async (e) => {
                          setFocusedIndex(index);
                          setIsSearching(true);
                          setSearchQuery("");
                          updateFloatingDropdownPosition(e.target);
                          await fetchProductsUnified({ page: 1, mode: "search" });
                        }}
                        onBlur={() => {
                          setTimeout(() => {
                            if (focusedIndex === index) {
                              setFocusedIndex(null);
                              setSearchResults([]);
                              setSearchQuery("");
                              setIsSearching(false);
                              closeFloatingDropdown();
                            }
                          }, 220);
                        }}
                      />


                    </td>

                    <td>
                      <input
                        type="text"
                        placeholder="Qty"
                        className="qinv-cell-input"
                        value={product.qty}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value >= 0 && value.length <= 4) {
                            handleInputChange(index, "qty", value);
                          }
                        }}
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .replace(/[^0-9]/g, "")
                            .slice(0, 4);
                        }}
                      />
                    </td>

                    <td>
                      <input
                        type="text"
                        placeholder="Rate"
                        className="qinv-cell-input qinv-cell-input-readonly"
                        readOnly
                        value={products[index].selling_price}
                        onChange={(e) =>
                          handleInputChange(index, "selling_price", e.target.value)
                        }
                      />
                    </td>

                    <td>
                      <input
                        type="text"
                        placeholder="UOM"
                        className="qinv-cell-input qinv-cell-input-readonly"
                        value={products[index].uom_title}
                        readOnly
                        onChange={(e) =>
                          handleInputChange(index, "per", e.target.value)
                        }
                      />
                    </td>

                    <td className="qinv-amount-cell">
                      {formatCurrency(Number(product.total || 0))}
                      {product.product_inventory && (
                        <button
                          type="button"
                          aria-label="Delete product"
                          onClick={() => handleDeleteRow(index)}
                          className="qinv-delete-btn"
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.00016 12.6667C4.00016 13.4 4.60016 14 5.3335 14H10.6668C11.4002 14 12.0002 13.4 12.0002 12.6667V6C12.0002 5.26667 11.4002 4.66667 10.6668 4.66667H5.3335C4.60016 4.66667 4.00016 5.26667 4.00016 6V12.6667ZM12.0002 2.66667H10.3335L9.86016 2.19333C9.74016 2.07333 9.56683 2 9.3935 2H6.60683C6.4335 2 6.26016 2.07333 6.14016 2.19333L5.66683 2.66667H4.00016C3.6335 2.66667 3.3335 2.96667 3.3335 3.33333C3.3335 3.7 3.6335 4 4.00016 4H12.0002C12.3668 4 12.6668 3.7 12.6668 3.33333C12.6668 2.96667 12.3668 2.66667 12.0002 2.66667Z"
                              fill="currentColor"
                            />
                          </svg>
                        </button>
                      )}
                    </td>
                  </tr>
                ))}

                <tr className="qinv-total-row">
                  <td colSpan="2" style={{ textAlign: "right" }}>
                    Total Values
                  </td>
                  <td>{totalQty}</td>
                  <td>{Number(totalRate || 0).toFixed(2)}</td>
                  <td>{uniquePer.join(", ")}</td>
                  <td>{formatCurrency(Number(totalAmount || 0))}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="qinv-bottom-grid">
          <div className="qinv-panel">
            <h2 className="qinv-section-title">Payment Details</h2>
            <p className="qinv-section-subtitle" style={{ marginBottom: "12px" }}>
              Select payment mode and review invoice note.
            </p>

            <div style={{ marginBottom: "14px" }}>
              <label className="qinv-label">Payment Method</label>
              <div className="qinv-payment-options">
                {["bank", "cash", "cheque", "terminal"].map((method) => (
                  <button
                    type="button"
                    key={method}
                    className={`qinv-payment-chip ${formData.pay_method === method ? "active" : ""}`}
                    onClick={() =>
                      setFormData((prev) => ({ ...prev, pay_method: method }))
                    }
                  >
                    {method === "bank"
                      ? "Bank Card"
                      : method === "terminal"
                      ? "Terminal"
                      : method.charAt(0).toUpperCase() + method.slice(1)}
                  </button>
                ))}
              </div>
            </div>

            {formData.pay_method === "terminal" && (
              <div style={{ marginBottom: "14px", display: "flex", flexDirection: "column", gap: "6px" }}>
                <label className="qinv-label">Select Terminal</label>
                {terminals.length > 0 ? (
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    {selectedTerminal && (
                      <img 
                        src={
                          selectedTerminal.provider === "CLOVER" ? "https://cloverstatic.com/web/apps/cloverdotcom/release::v2.142.0-f81e9288a386b/assets/media/clover-logo.5637c88fda21055b797e300e16140c95.svg" :
                          selectedTerminal.provider === "STRIPE" ? "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Stripe_Logo%2C_revised_2016.svg/330px-Stripe_Logo%2C_revised_2016.svg.png?utm_source=commons.wikimedia.org&utm_campaign=index&utm_content=thumbnail" :
                          selectedTerminal.provider === "SQUARE" ? "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Square%2C_Inc._logo.svg/3840px-Square%2C_Inc._logo.svg.png?utm_source=commons.wikimedia.org&utm_campaign=index&utm_content=thumbnail" :
                          selectedTerminal.provider === "ADYEN" ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLwbTNAl15w8i2X2hvS1FQlVFTRuJbEAoi_m2aUJwGJ1RhL18li_Po4fQ&s=10" :
                          selectedTerminal.provider === "PINE_LABS" ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQSWMtmHPJkKFRxPBaCiw49vdQNLgBaxtG9Ls2hwYr2LY2RXP0KkMsG9WcJ&s=10" :
                          selectedTerminal.provider === "PAYTM" ? "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Paytm_Logo_%28standalone%29.svg/1280px-Paytm_Logo_%28standalone%29.svg.png?utm_source=commons.wikimedia.org&utm_campaign=index&utm_content=thumbnail" : ""
                        } 
                        alt={selectedTerminal.provider} 
                        style={{ height: '24px', maxWidth: '80px', objectFit: 'contain' }} 
                      />
                    )}
                    <select
                      value={selectedTerminal?.id || ""}
                      onChange={(e) => {
                        const found = terminals.find(t => t.id === e.target.value);
                        setSelectedTerminal(found);
                      }}
                      style={{
                        padding: '10px 14px',
                        borderRadius: '12px',
                        border: '1px solid #cbd5e1',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        background: '#ffffff',
                        color: '#0f172a',
                        outline: 'none',
                        minWidth: '220px'
                      }}
                    >
                      {terminals.map(t => (
                        <option key={t.id} value={t.id}>{t.name} ({t.provider})</option>
                      ))}
                    </select>
                  </div>
                ) : (
                  <span style={{ fontSize: '13px', color: '#dc2626', fontWeight: 'bold' }}>
                    No active terminals. Please configure a terminal in Settings.
                  </span>
                )}
              </div>
            )}

            <div>
              <label htmlFor="note" className="qinv-label">
                Note
              </label>
              <textarea
                id="note"
                rows="4"
                value={formData.note}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, note: e.target.value }))
                }
                readOnly
                className="qinv-note"
              />
            </div>
          </div>

          <div className="qinv-panel qinv-summary-panel">
            <h2 className="qinv-section-title">Invoice Summary</h2>
            <p className="qinv-section-subtitle" style={{ marginBottom: "12px" }}>
              Final amount after discount and round-off.
            </p>

            <div className="qinv-roundoff-row">
              <span className="qinv-label" style={{ marginBottom: 0 }}>
                Round Off
              </span>
              <div className="qinv-roundoff-toggle">
                <label className={`qinv-toggle-option ${roundOffEnabled ? "active" : ""}`}>
                  <input
                    type="radio"
                    value="yes"
                    checked={roundOffEnabled}
                    onChange={handleRoundOffChange}
                    style={{ display: "none" }}
                  />
                  Yes
                </label>
                <label className={`qinv-toggle-option ${!roundOffEnabled ? "active" : ""}`}>
                  <input
                    type="radio"
                    value="no"
                    checked={!roundOffEnabled}
                    onChange={handleRoundOffChange}
                    style={{ display: "none" }}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="qinv-summary-line">
              <span>Total Quantity</span>
              <strong>{totalQty || 0}</strong>
            </div>
            <div className="qinv-summary-line">
              <span>Total Amount</span>
              <strong>{formatCurrency(Number(totalAmount || 0))}</strong>
            </div>
            <div className="qinv-summary-line">
              <span>Discounted Total</span>
              <strong>{formatCurrency(Number(totalDiscounted || 0))}</strong>
            </div>

            <div className="qinv-payable-box">
              <div>
                <div className="qinv-payable-label">Payable Amount</div>
                <div className="qinv-section-subtitle" style={{ color: "rgba(255,255,255,0.70)" }}>
                  Ready for Save & Print
                </div>
              </div>
              <div className="qinv-payable-value">
                {formatCurrency(typeof finalPayableAmount === "number" && !isNaN(finalPayableAmount)
                  ? finalPayableAmount
                  : 0)}
              </div>
            </div>
          </div>
        </div>

        <div className="qinv-actions">
          <button
            type="button"
            className="qinv-btn qinv-btn-clear"
            onClick={handleCancel}
          >
            Clear
          </button>

          <button
            type="button"
            className="qinv-btn qinv-btn-primary"
            onClick={() => handleSubmit(true)}
          >
            Save & Print
          </button>
        </div>

        {focusedIndex !== null && floatingDropdownStyle && (
          <>
            {searchResults.length > 0 ? (
              <ul
                className="qinv-search-results"
                style={{
                  top: `${floatingDropdownStyle.top}px`,
                  left: `${floatingDropdownStyle.left}px`,
                  width: `${floatingDropdownStyle.width}px`,
                }}
              >
                {searchResults
                  .filter(
                    (item) =>
                      item.segments &&
                      item.segments.some((segment) => segment.inventory_available)
                  )
                  .map((item) => (
                    <li
                      key={item.id}
                      onMouseDown={(event) => {
                        event.preventDefault();
                        handleSelectProduct(focusedIndex, item);
                        closeFloatingDropdown();
                      }}
                      className="qinv-search-item"
                    >
                      {item.title}
                    </li>
                  ))}
              </ul>
            ) : (
              !loading && (
                <div
                  className="qinv-search-empty"
                  style={{
                    top: `${floatingDropdownStyle.top}px`,
                    left: `${floatingDropdownStyle.left}px`,
                    width: `${floatingDropdownStyle.width}px`,
                  }}
                >
                  No products found
                </div>
              )
            )}
          </>
        )}

        <QuickInvoicemodal
          open={showInvoice}
          onClose={handleCloseModal}
          data={modalData}
          onPrint={handlePrint}
          invoiceType="retail"
        />

        {showTerminalModal && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.6)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
          }}>
            <div style={{
              background: '#ffffff',
              padding: '30px',
              borderRadius: '12px',
              width: '400px',
              textAlign: 'center',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>
                {terminalStatus === "CONNECTING" && "🔌"}
                {terminalStatus === "WAITING_FOR_CUSTOMER" && "💳"}
                {terminalStatus === "PROCESSING" && "🔄"}
                {terminalStatus === "SUCCESS" && "✅"}
                {terminalStatus === "FAILED" && "❌"}
              </div>
              <h3 style={{ margin: '0 0 10px 0', fontSize: '20px', color: '#0f172a' }}>
                {terminalStatus === "CONNECTING" && "Connecting to Terminal"}
                {terminalStatus === "WAITING_FOR_CUSTOMER" && "Swipe / Tap / Insert Card"}
                {terminalStatus === "PROCESSING" && "Processing Payment"}
                {terminalStatus === "SUCCESS" && "Payment Successful"}
                {terminalStatus === "FAILED" && "Payment Failed"}
              </h3>
              <p style={{ color: '#475569', fontSize: '14px', margin: '0 0 20px 0', minHeight: '40px', lineHeight: '1.5' }}>
                {terminalMessage}
              </p>
              {terminalStatus === "WAITING_FOR_CUSTOMER" && selectedTerminal && (
                <div style={{ margin: '0 0 20px 0', padding: '10px', background: '#eff6ff', borderRadius: '8px', border: '1px solid #bfdbfe' }}>
                  <a 
                    href={
                      selectedTerminal.provider === "CLOVER" ? "https://sandbox.dev.clover.com/" :
                      selectedTerminal.provider === "STRIPE" ? "https://stripe.com/docs/terminal/references/testing#simulated-reader" :
                      selectedTerminal.provider === "SQUARE" ? "https://developer.squareup.com/docs/terminal-api/testing" :
                      selectedTerminal.provider === "ADYEN" ? "https://docs.adyen.com/point-of-sale/testing-terminals" :
                      selectedTerminal.provider === "PINE_LABS" ? "https://developer.pinelabs.com/" :
                      selectedTerminal.provider === "PAYTM" ? "https://developer.paytm.com/docs/pos/" : "#"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ fontSize: '13px', color: '#1d4ed8', fontWeight: 'bold', textDecoration: 'underline' }}
                  >
                    👉 Open {selectedTerminal.provider} Simulator / Testing Docs
                  </a>
                </div>
              )}
              {terminalStatus === "FAILED" && (
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                  <button
                    onClick={() => handleSubmit(true)}
                    style={{
                      padding: '8px 16px',
                      background: '#0284c7',
                      color: '#ffffff',
                      border: 'none',
                      borderRadius: '6px',
                      fontWeight: 'bold',
                      cursor: 'pointer'
                    }}
                  >
                    Try Again
                  </button>
                  <button
                    onClick={() => {
                      if (pollingRef.current) clearInterval(pollingRef.current);
                      setShowTerminalModal(false);
                    }}
                    style={{
                      padding: '8px 16px',
                      background: '#cbd5e1',
                      color: '#334155',
                      border: 'none',
                      borderRadius: '6px',
                      fontWeight: 'bold',
                      cursor: 'pointer'
                    }}
                  >
                    Cancel
                  </button>
                </div>
              )}
              {terminalStatus !== "FAILED" && terminalStatus !== "SUCCESS" && (
                <button
                  onClick={() => {
                    if (pollingRef.current) clearInterval(pollingRef.current);
                    setShowTerminalModal(false);
                  }}
                  style={{
                    padding: '8px 16px',
                    background: '#cbd5e1',
                    color: '#334155',
                    border: 'none',
                    borderRadius: '6px',
                    fontWeight: 'bold',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );

}

export default QuickInvoice;